import { Grid, IconButton, styled } from "@material-ui/core";
import ExploreIcon from "@material-ui/icons/Explore";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import { ContractStore } from "store";
import { ListIcon } from "../../assets/icons/CustomSVGIcons";

const LeftBarContainer = styled(Grid)(({ theme }) => ({
  width: 40,
  // backgroundColor: theme.palette.gray.dark,
  backgroundColor: "#000000",
  height: "100vh",
  paddingTop: theme.spacing(1),
}));

const LeftBarButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.gray.main,
  padding: theme.spacing(2),
  margin: theme.spacing(1, 0),
}));

const LeftBar = () => (
  <LeftBarContainer container item alignItems="center" direction="column">
    <LeftBarButton>
      <ExploreIcon />
    </LeftBarButton>
    <LeftBarButton>
      <GroupWorkIcon />
    </LeftBarButton>
    <LeftBarButton
      onClick={() => {
        ContractStore.openAddsAndCancelsMenu();
      }}
    >
      <ListIcon />
    </LeftBarButton>
  </LeftBarContainer>
);

export default LeftBar;
